module.exports = {
  id: 'newsletterForm',
  method: 'post',
  target: '_blank',
  action: 'https://eu2.cleverreach.com/f/146712-146368/wcs/',
  cells: [
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'firstname',
      label: 'Firstname',
      placeholder: 'Firstname'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'lastname',
      label: 'Lastname',
      placeholder: 'Lastname'
    },
    {
      fieldType: 'select',
      name: 'sprache',
      label: 'Sprache',
      options: [
        {
          value: 'Englisch',
          text: 'Englisch'
        },
        {
          value: 'Deutsch',
          text: 'Deutsch'
        }
      ],
      required: true
    },
    {
      fieldType: 'input',
      name: 'email',
      type: 'email',
      label: 'Mail',
      placeholder: 'Mail',
      required: true
    }
  ],
  submitText: 'Submit'
};
